import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDesktopSkeleton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 700 278"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect rx={4} fill="#fff" />
    <path d="M256 247h232.645M256 263h172.992" stroke="#E6E6E6" />
    <path
      d="M342.78 221.46c2.54 0 4.02-1.8 4.02-3.9 0-2.1-1.46-3.9-4.02-3.9h-5v6.74l-1.2-.02v1.08h1.2v1.66h-1.2v1.08h1.2v2.8h1.14v-2.8h4.62v-1.04l-4.62-.02v-1.68h3.86Zm-3.86-6.76h3.74c1.76 0 2.94 1.18 2.94 2.86s-1.18 2.86-2.94 2.86h-3.74v-5.72Z"
      fill="#E6E6E6"
    />
    <path
      d="M352 224h68.502M258 228.413 273.413 213M268 228.413 283.413 213M278 228.413 293.413 213M298 228.413 313.413 213M308 228.413 323.413 213M318 228.413 333.413 213M262.548 19.508l-.233-.123-.232.122-3.007 1.58.575-3.344.044-.26-.188-.183-2.432-2.367 3.361-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.361.488-2.432 2.367-.188.184.044.259.575 3.343-3.007-1.578ZM276.409 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.361-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.361.488-2.432 2.367-.188.184.044.259.574 3.343-3.006-1.578ZM290.27 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.361-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.431 2.367-.188.184.044.259.574 3.343-3.006-1.578ZM304.131 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.431 2.367-.188.184.044.259.574 3.343-3.006-1.578ZM317.992 19.508l-.233-.123-.232.122-3.007 1.58.574-3.344.045-.26-.189-.183-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.503 3.043.117.235.26.038 3.36.488-2.431 2.367-.188.184.044.259.574 3.343-3.006-1.578Z"
      stroke="#E6E6E6"
    />
    <path
      clipRule="evenodd"
      d="M680.044 28c.984-.409 9.956-4.316 9.956-10.873 0-6.938-5.876-6.095-5.876-6.095s-2.859.315-4.124 2.707c-1.265-2.392-4.124-2.707-4.124-2.707S670 10.19 670 17.127c0 6.557 8.972 10.464 9.956 10.873h.088Z"
      stroke="#E6E6E6"
      strokeLinejoin="round"
    />
    <path
      d="m256 49.636 15.413-15.412M266 49.636l15.413-15.412M276 49.636l15.413-15.412M286 49.636l15.413-15.412M296 49.636l15.413-15.412M316 49.636l15.413-15.412M326 49.636l15.413-15.412M336 49.636l15.413-15.412M346 49.636l15.413-15.412M356 49.636l15.413-15.412M366 49.636l15.413-15.412M376 49.636l15.413-15.412M396 49.636l15.413-15.412M406 49.636l15.413-15.412"
      stroke="#E6E6E6"
    />
    <path d="M0 4a4 4 0 0 1 4-4h236v278H4a4 4 0 0 1-4-4V4Z" fill="#E6E6E6" />
    <path
      clipRule="evenodd"
      d="M272.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5ZM324.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5Z"
      stroke="#E6E6E6"
    />
    <rect x={361.5} y={66.5} width={56} height={30} rx={15} stroke="#E6E6E6" />
    <path
      clipRule="evenodd"
      d="M454.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5ZM504.5 97c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5Z"
      stroke="#E6E6E6"
    />
    <path
      d="M256 106h36.201M307 106h36.201M490 106h31.504M431 106h48.58M362 106h55.52"
      stroke="#E6E6E6"
    />
  </svg>
);
const Memo = memo(SvgDesktopSkeleton);
export default Memo;
